import { Header } from "@/components/Header";
import { PremiumFooter } from "@/components/landing/PremiumFooter";
import { Cookie } from "lucide-react";

const Cookies = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <section className="pt-24 pb-16">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
              <Cookie className="w-8 h-8 text-primary" />
            </div>
            <h1 className="text-4xl font-bold text-foreground mb-4 font-display">
              Politique de Cookies
            </h1>
            <p className="text-muted-foreground">Dernière mise à jour : 3 décembre 2024</p>
          </div>

          <div className="prose prose-invert max-w-none">
            <div className="bg-card border border-border rounded-2xl p-8 space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">1. Qu'est-ce qu'un cookie ?</h2>
                <p className="text-muted-foreground">
                  Un cookie est un petit fichier texte stocké sur votre appareil lors de votre visite sur notre site. 
                  Les cookies nous permettent de vous reconnaître et de personnaliser votre expérience.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">2. Types de cookies utilisés</h2>
                
                <h3 className="text-xl font-medium text-foreground mt-6 mb-3">Cookies essentiels</h3>
                <p className="text-muted-foreground">
                  Nécessaires au fonctionnement du site : authentification, sécurité, préférences de session. 
                  Ces cookies ne peuvent pas être désactivés.
                </p>

                <h3 className="text-xl font-medium text-foreground mt-6 mb-3">Cookies analytiques</h3>
                <p className="text-muted-foreground">
                  Nous permettent de comprendre comment vous utilisez Floop pour améliorer nos services. 
                  Les données sont anonymisées.
                </p>

                <h3 className="text-xl font-medium text-foreground mt-6 mb-3">Cookies de préférences</h3>
                <p className="text-muted-foreground">
                  Mémorisent vos préférences (langue, thème) pour personnaliser votre expérience.
                </p>

                <h3 className="text-xl font-medium text-foreground mt-6 mb-3">Cookies marketing</h3>
                <p className="text-muted-foreground">
                  Utilisés pour vous présenter des publicités pertinentes. Vous pouvez les désactiver à tout moment.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">3. Liste des cookies utilisés</h2>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-border">
                        <th className="text-left p-3 text-foreground">Nom</th>
                        <th className="text-left p-3 text-foreground">Type</th>
                        <th className="text-left p-3 text-foreground">Durée</th>
                        <th className="text-left p-3 text-foreground">Description</th>
                      </tr>
                    </thead>
                    <tbody className="text-muted-foreground">
                      <tr className="border-b border-border/50">
                        <td className="p-3">floop_session</td>
                        <td className="p-3">Essentiel</td>
                        <td className="p-3">Session</td>
                        <td className="p-3">Gestion de votre session utilisateur</td>
                      </tr>
                      <tr className="border-b border-border/50">
                        <td className="p-3">floop_auth</td>
                        <td className="p-3">Essentiel</td>
                        <td className="p-3">30 jours</td>
                        <td className="p-3">Authentification persistante</td>
                      </tr>
                      <tr className="border-b border-border/50">
                        <td className="p-3">floop_prefs</td>
                        <td className="p-3">Préférence</td>
                        <td className="p-3">1 an</td>
                        <td className="p-3">Vos préférences d'affichage</td>
                      </tr>
                      <tr className="border-b border-border/50">
                        <td className="p-3">_ga</td>
                        <td className="p-3">Analytique</td>
                        <td className="p-3">2 ans</td>
                        <td className="p-3">Google Analytics</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">4. Gestion des cookies</h2>
                <p className="text-muted-foreground">
                  Vous pouvez gérer vos préférences de cookies à tout moment via les paramètres de votre navigateur 
                  ou via notre bandeau de consentement. La désactivation de certains cookies peut affecter votre expérience.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">5. Durée de conservation</h2>
                <p className="text-muted-foreground">
                  Les cookies de session sont supprimés à la fermeture du navigateur. Les cookies persistants 
                  ont une durée maximale de 13 mois conformément aux recommandations de la CNIL.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">6. Contact</h2>
                <p className="text-muted-foreground">
                  Pour toute question concernant notre politique de cookies :
                  <a href="mailto:privacy@floop.ai" className="text-primary hover:underline ml-1">privacy@floop.ai</a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>

      <PremiumFooter />
    </div>
  );
};

export default Cookies;
